<template>
  <div class="panel mb-20 mobile-mb-20" v-if="service_quests.length > 0">
    <div class="header flex-row-between">
      <h2>我的工单</h2>
      <router-link
        to="/dashboard/service_quests/grab"
        class="text-primary font-12"
        >去领取</router-link
      >
    </div>
    <ul class="messages">
      <li v-for="item in service_quests" :key="item.id">
        <router-link
          class="flex-row-between"
          :to="`/dashboard/service_quests/list/${item.id}`"
        >
          <span class="content">
            <!-- <i :class="{ unread: item.status == 1 }"></i> -->
            <span style="flex: 1"
              >{{ item.number }}（{{ item.customer.name }}）</span
            >
          </span>
          <span class="date">{{ formatTime(item.created_at) }}</span>
        </router-link>
      </li>
    </ul>
    <!-- <div v-else class="text-info-12">暂无待处理工单</div> -->
  </div>
</template>

<script>
import { serviceQuestList } from '@/service/getData'
import { formatTime } from '@/util/index'

export default {
  data() {
    return {
      service_quests: [],
      formatTime,
    }
  },

  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await serviceQuestList({
        page: 0,
        size: 20,
        is_grab_user: true,
      })

      if (res.code == 0) {
        this.service_quests = res.data.list || []
      }
    },
  },
}
</script>

<style scoped>
.messages li {
  padding: 10px 0;
  color: #555;
}
.messages li a {
  color: #333;
}

.messages li .date {
  color: #999;
  width: 100px;
  text-align: right;
}

.messages li .content {
  flex: 1;
  display: flex;
  align-items: center;
}
</style>